import type { CommonOptions } from "@/shared/ui";

export const PRODUCT_REQUISITION_TIME: CommonOptions = [
	{ label: "Azonnal", value: "IMMEDIETLY" },
	{ label: "1-2 hét", value: "ONE_TWO_WEEKS" },
	{ label: "3-4 hét", value: "THREE_FOUR_WEEKS" },
	{ label: "2-3 hónap múlva", value: "TWO_THREE_MONTHS" },
	{ label: "4-6 hónap múlva", value: "FOUR_SIX_MONTHS" },
	{ label: "Egyelőre csak tájékozódom", value: "TBD" },
];
